/**
 * ListTopUtil
 */

import Config from '../Config';
import Util from '../Util';
import Template from './Template';
import DropdownLayer from '../DropdownLayer';
import PageNavigation from './PageNavigation';
import ParamInfo from "./ParamInfo";

class ListTopUtil {

	public onViewMode: any;

	public onWrite: any;

	private $node: any;

	private _$node: any;

	private _$listCountNode: any;

	private viewMode: any;

    private paramInfo: any;

	constructor( node: any ) {
		this.$node = node;
		this._$node = jQuery( Template.listTop() );
		this.paramInfo = new ParamInfo();
		this.paramInfo.setParamByUrl();
		const _query = this.paramInfo.getParamByKey( 'query' );
		const _searchType = this.paramInfo.getParamByKey( 'searchType' );

		this._$listCountNode = jQuery( this._$node ).find( '.list-count-area' );

		this.setUI();
		this.addEvent();

		this.onViewMode = new Util.Observer();
		this.onWrite = new Util.Observer();

		this.viewMode =  Util.getParams().viewMode || 'list';

		( this.viewMode === 'list' || this.viewMode === 'thumb' ) ?
			this.showCardButton() :
			this.showListButton();
		if ( _query && _searchType !== 'tag' ) {
            this.$node.find('.wrap-btn-type').hide();
        }
	}

	public showCardButton() {
		this.$node.find( '.btn-list' ).removeClass('is-disabled');
		this.$node.find( '.btn-cards' ).addClass('is-disabled');
		this.$node.find( '.btn-type-selected').addClass('list');
	}

	public showListButton() {
		this.$node.find( '.btn-list' ).addClass('is-disabled');
		this.$node.find( '.btn-cards' ).removeClass('is-disabled');
		this.$node.find( '.btn-type-selected').addClass('card');
	}

	public showButtonType( viewMode: string ) {
		( viewMode === 'list' || viewMode === 'thumb' ) ?
			this.showCardButton() :
			this.showListButton();
	}

	public getNode() {
		return this._$node;
	}

	public getListSizeNode() {
		return this._$listCountNode;
	}

	private setUI() {
		this.$node.append( this._$node );
	}

	private addEvent() {
        this.$node.on( 'click', '.btn-type-selected', ( evt: any ) => {
            evt.preventDefault();
            this.$node.find( '.btn-type-selected' ).toggleClass('is-show');
        });

        this.$node.on( 'click', '.btn-write', ( evt: any ) => {
			evt.preventDefault();
			this.onWrite.emit();
		});

        this.$node.on( 'click', '.btn-reload', ( evt: any ) => {
			evt.preventDefault();
			location.reload();
		});

        this.$node.on( 'click', '.btn-cards', ( evt: any ) => {
			evt.preventDefault();
			this.onViewMode.emit( 'card' );
		});

        this.$node.on( 'click', '.btn-list', ( evt: any ) => {
			evt.preventDefault();
			this.onViewMode.emit( 'list' );
		});
	}
}

export default ListTopUtil;
